import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";

import { showLoader, hideLoader, showAlert, isEmpty, showContaimerLoader, isEmail, removeChar, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
const module = "portagent";
const modulePath = "/portagent";
const moduleName = "Port Agent";
const moduleID = 9;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        portAgentName: "",
        contactPerson: "",
        address: "",
        phone: "",
        email: "",
        city: "",
        state: "",
        country: "",
      },
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;

          const clientupdatedata = {
            portAgentName: result.portAgentName,
            contactPerson: result.contactPerson,
            address: result.address,
            phone: result.phone,
            email: result.email,
            city: result.city,
            state: result.state,
            country: result.country,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;

    const postObject = {
      portAgentName: postData.portAgentName.toUpperCase(),
      contactPerson: postData.contactPerson.toUpperCase(),
      address: postData.address.toUpperCase(),
      phone: postData.phone,
      email: postData.email,
      city: postData.city.toUpperCase(),
      state: postData.state.toUpperCase(),
      country: postData.country.toUpperCase(),
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { portAgentName, contactPerson, address, phone, email, city, state, country } = props.fields;

  return {
    fields: ["portAgentName", "contactPerson", "address", "phone", "email", "city", "state", "country"],
    validations: {
      portAgentName: [[isEmpty, portAgentName]],
      contactPerson: [[isEmpty, contactPerson]],
      address: [[isEmpty, address]],
      phone: [
        [isEmpty, phone]
      ],
      email: [
        [isEmpty, email],
        [isEmail, email],
      ],
      city: [[isEmpty, city]],
      state: [[isEmpty, state]],
      country: [[isEmpty, country]],
    },
  };
}

class PostForm extends Component {
  goBack() {
    this.props.history.push(modulePath);
  }
  
  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgportAgentName,
      errMsgcontactPerson,
      errMsgaddress,
      errMsgphone,
      errMsgemail,
      errMsgcity,
      errMsgstate,
      errMsgcountry = "";
    if ($validation.portAgentName.error.reason !== undefined) {
      errMsgportAgentName = $validation.portAgentName.show && <span className="error">{$validation.portAgentName.error.reason}</span>;
    }
    if ($validation.contactPerson.error.reason !== undefined) {
      errMsgcontactPerson = $validation.contactPerson.show && <span className="error">{$validation.contactPerson.error.reason}</span>;
    }
    if ($validation.address.error.reason !== undefined) {
      errMsgaddress = $validation.address.show && <span className="error">{$validation.address.error.reason}</span>;
    }

    if ($validation.phone.error.reason !== undefined) {
      errMsgphone = $validation.phone.show && <span className="error">{$validation.phone.error.reason}</span>;
    }
    if ($validation.email.error.reason !== undefined) {
      errMsgemail = $validation.email.show && <span className="error">{$validation.email.error.reason}</span>;
    }
    if ($validation.city.error.reason !== undefined) {
      errMsgcity = $validation.city.show && <span className="error">{$validation.city.error.reason}</span>;
    }

    if ($validation.state.error.reason !== undefined) {
      errMsgstate = $validation.state.show && <span className="error">{$validation.state.error.reason}</span>;
    }
    if ($validation.country.error.reason !== undefined) {
      errMsgcountry = $validation.country.show && <span className="error">{$validation.country.error.reason}</span>;
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Port Agent Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Port Agent Name"
                name="portAgentName"
                value={fields.portAgentName}
                {...$field("portAgentName", (e) => onChange("portAgentName", e.target.value))}
              />
              {errMsgportAgentName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Contact Person<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Contact Person"
                name="contactPerson"
                value={fields.contactPerson}
                {...$field("contactPerson", (e) => onChange("contactPerson", e.target.value))}
              />
              {errMsgcontactPerson}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Address<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control upper-case" placeholder="Address" name="address" value={fields.address} {...$field("address", (e) => onChange("address", e.target.value))} />
              {errMsgaddress}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Phone Number<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control" placeholder="Phone Number" name="phone" value={fields.phone} {...$field("phone", (e) => onChange("phone", e.target.value))} />
              {errMsgphone}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Email<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control" placeholder="Email" name="email" value={fields.email} {...$field("email", (e) => onChange("email", e.target.value))} />
              {errMsgemail}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                City<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control upper-case" placeholder="City" name="city" value={fields.city} {...$field("city", (e) => onChange("city", e.target.value))} />
              {errMsgcity}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                State<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control upper-case" placeholder="State" name="state" value={fields.state} {...$field("state", (e) => onChange("state", e.target.value))} />
              {errMsgstate}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Country<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control upper-case" placeholder="Country" name="country" value={fields.country} {...$field("country", (e) => onChange("country", e.target.value))} />
              {errMsgcountry}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
